import type { Anchor, Edge, EdgeDimension, GeometricConnector } from "./types.ts";

const edgeToEdgeDimension: Record<Edge, EdgeDimension> = {
  RIGHT: "HORIZONTAL",
  LEFT: "HORIZONTAL",
  TOP: "VERTICAL",
  BOTTOM: "VERTICAL",
};

const getEdgeDimension = (edge: Edge) => edgeToEdgeDimension[edge];

const getParallelEdgesDistance = (edge: Edge, deltaX: number, deltaY: number): number => {
  switch (edge) {
    case "RIGHT":
      return deltaX;

    case "LEFT":
      return -deltaX;

    case "BOTTOM":
      return deltaY;

    case "TOP":
      return -deltaY;
  }
};

export const getGeometricConnector = (from: Anchor, to: Anchor): GeometricConnector => {
  const isParallel = getEdgeDimension(from.edge) === getEdgeDimension(to.edge);
  const isOpposite = isParallel && from.edge !== to.edge;

  const parallelEdgesDistance = !isParallel
    ? null
    : getParallelEdgesDistance(from.edge, to.point.x - from.point.x, to.point.y - from.point.y);

  const isOppositeAndInversed = isOpposite && parallelEdgesDistance !== null && parallelEdgesDistance < 0;
  const isOppositeAndClose =
    isOpposite && parallelEdgesDistance !== null && parallelEdgesDistance >= 0 && parallelEdgesDistance < 30;

  return {
    from,
    to,
    isParallel,
    isOpposite,
    isOppositeAndInversed,
    isOppositeAndClose,
    parallelEdgesDistance,
  };
};
